import type { FamsAppRoleMe } from '@/services/bff/types/app-role';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        currentUser?: API.CurrentUser;
        appRoles?: FamsAppRoleMe;
      }
    | undefined,
) {
  const { currentUser, appRoles } = initialState ?? {};
  const isAdmin = Boolean(appRoles?.isAdmin || currentUser?.type === 'admin');
  return {
    canAdmin: isAdmin,
    canManageRoles: Boolean(appRoles?.canManageRoles || isAdmin),
    canManageMembers: Boolean(
      appRoles?.canManageMembers || appRoles?.canManageRoles || isAdmin,
    ),
    canReviewApprovals: Boolean(appRoles?.canReview || isAdmin),
    canSubmitApprovals: Boolean(appRoles?.canSubmit || isAdmin),
  };
}
